import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { Link } from "react-router-dom";
import { Cookie } from "lucide-react";

const KEY = "dvmart_cookie_consent";

export const CookieConsent = () => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem(KEY)) setShow(true);
  }, []);

  const decide = (value) => {
    localStorage.setItem(KEY, value);
    setShow(false);
  };

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          initial={{ y: 120, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 120, opacity: 0 }}
          transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
          className="fixed bottom-4 left-4 right-4 sm:left-auto sm:right-6 sm:max-w-md z-[60]"
          data-testid="cookie-consent"
        >
          <div className="bg-white/80 backdrop-blur-xl border border-white/50 shadow-[0_20px_40px_-15px_rgba(0,0,0,0.2)] p-6">
            <div className="flex items-start gap-3">
              <span className="w-9 h-9 shrink-0 bg-foreground text-white flex items-center justify-center">
                <Cookie size={17} />
              </span>
              <div>
                <h3 className="font-display text-xl leading-none tracking-tight text-foreground">
                  We use cookies
                </h3>
                <p className="mt-2 text-sm text-muted-foreground leading-relaxed">
                  We use basic cookies to keep our website running smoothly. Your data stays with us —
                  we never sell or share it. See our{" "}
                  <Link to="/privacy" className="text-accent hover:underline" data-testid="cookie-privacy-link">
                    Privacy Policy
                  </Link>
                  .
                </p>
              </div>
            </div>
            <div className="mt-5 flex items-center gap-3">
              <button
                onClick={() => decide("accepted")}
                className="flex-1 bg-foreground text-white py-3 text-xs font-mono-label uppercase tracking-widest hover:bg-accent transition-colors duration-300"
                data-testid="cookie-accept"
              >
                Accept
              </button>
              <button
                onClick={() => decide("declined")}
                className="px-5 py-3 text-xs font-mono-label uppercase tracking-widest border border-foreground/25 hover:border-foreground transition-colors duration-300"
                data-testid="cookie-decline"
              >
                Decline
              </button>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
